import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=9ac00bac&scoped=true"
import script from "./Exam.vue?vue&type=script&lang=js"
export * from "./Exam.vue?vue&type=script&lang=js"
import style0 from "./Exam.vue?vue&type=style&index=0&id=9ac00bac&prod&lang=scss&scoped=true"
import style1 from "./Exam.vue?vue&type=style&index=1&id=9ac00bac&prod&lang=scss"
import style2 from "./Exam.vue?vue&type=style&index=2&id=9ac00bac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac00bac",
  null
  
)

export default component.exports